import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { Typography, Row, Col, Card, Statistic } from 'antd'
import IMappingStatsPending from '../../interfaces/IMappingStatsPending'

type MappingStatsProps = {
  loading: boolean,
  mappingPending: IMappingStatsPending | null,

  loadMappingPending: () => void,
  /** Notifies the owner when a card is clicked so it can force a refetch on a no-op navigation. */
  onCardClick?: (e: React.MouseEvent, tab: string) => void
}

export default class MappingStats extends Component<MappingStatsProps> {

  static defaultProps = {
    loading: false
  }

  componentDidMount() {
    const { loading, loadMappingPending } = this.props

    if (!loading) {
      loadMappingPending()
    }
  }

  renderAgeStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`age?filter_active=false`} onClick={(e) => this.props.onCardClick?.(e, 'age')}>
        <Card loading={loading}>
          <Statistic
            title="Age"
            value={mappingPending?.mapping_age || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderBreedStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`breed?filter_active=false`} onClick={(e) => this.props.onCardClick?.(e, 'breed')}>
        <Card loading={loading}>
          <Statistic
            title="Breed"
            value={mappingPending?.mapping_breed || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderSexStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`sex?filter_active=false`} onClick={(e) => this.props.onCardClick?.(e, 'sex')}>
        <Card loading={loading}>
          <Statistic
            title="Sex"
            value={mappingPending?.mapping_sex || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderSizeStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`size?filter_active=false`} onClick={(e) => this.props.onCardClick?.(e, 'size')}>
        <Card loading={loading}>
          <Statistic
            title="Size"
            value={mappingPending?.mapping_size || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderSpecieStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`specie?filter_active=false`} onClick={(e) => this.props.onCardClick?.(e, 'specie')}>
        <Card loading={loading}>
          <Statistic
            title="Species"
            value={mappingPending?.mapping_specie || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderCharacteristicStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`characteristic?filter_active=false`} onClick={(e) => this.props.onCardClick?.(e, 'characteristic')}>
        <Card loading={loading}>
          <Statistic
            title="Characteristic"
            value={mappingPending?.mapping_characteristic || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderColorStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`color?filter_active=false`} onClick={(e) => this.props.onCardClick?.(e, 'color')}>
        <Card loading={loading}>
          <Statistic
            title="Color"
            value={mappingPending?.mapping_color || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderBranchStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`branch?filter_active=false`} onClick={(e) => this.props.onCardClick?.(e, 'branch')}>
        <Card loading={loading}>
          <Statistic
            title="Location"
            value={mappingPending?.mapping_branch || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  renderStateStats = (loading: boolean) => {
    const { mappingPending } = this.props

    return (
      <Link to={`state?filter_active=false`} onClick={(e) => this.props.onCardClick?.(e, 'state')}>
        <Card loading={loading}>
          <Statistic
            title="State"
            value={mappingPending?.mapping_state || 0}
            precision={0}
          />
        </Card>
      </Link>
    )
  }

  render() {
    const { loading } = this.props
    const breakpoints = {
      xs: 24,
      sm: 12,
      md: 8,
      lg: 6,
      xl: 4,
      xxl: 3,
    }

    return (
      <>
        <Typography.Title level={3}>Pending Mappings</Typography.Title>

        <Row gutter={[8, 8]}>
          <Col {...breakpoints}>
            {this.renderAgeStats(loading)}
          </Col>

          <Col {...breakpoints}>
            {this.renderBreedStats(loading)}
          </Col>

          <Col {...breakpoints}>
            {this.renderSexStats(loading)}
          </Col>

          <Col {...breakpoints}>
            {this.renderSizeStats(loading)}
          </Col>

          <Col {...breakpoints}>
            {this.renderSpecieStats(loading)}
          </Col>

          <Col {...breakpoints}>
            {this.renderColorStats(loading)}
          </Col>

          <Col {...breakpoints}>
            {this.renderCharacteristicStats(loading)}
          </Col>

          <Col {...breakpoints}>
            {this.renderBranchStats(loading)}
          </Col>

          {/* TODO: nao sei se faz sentido ainda */}
          {/* <Col {...breakpoints}>
            {this.renderStateStats(loading)}
          </Col> */}
        </Row>
      </>
    )
  }
}
